export const canPerformFinancialOperation = ({ authId, item }) => {
  if (String(item?.id) === String(authId)) {
    return true;
  }

  const directParentId = item?.parentAgent?.id;

  if (!directParentId || String(directParentId) === String(authId)) {
    return true;
  }

  return !(item.parentAgent?.isHigherAgentsOperationsRestricted ?? false);
};

export const canPerformFinancialOperationByUserInfo = ({ authId, userInfo }) => {
  if (!userInfo?.id) {
    return true;
  }

  const isDirectAgent = String(userInfo.parentAgentId) === String(authId);

  if (isDirectAgent) {
    return true;
  }

  return !(userInfo.parentInfo?.isHigherAgentsOperationsRestricted ?? false);
};
